import PaintingCard from './PaintingCard';

const PaintingList = ({ paintings }) => {
    if (!paintings || paintings.length === 0) {
        return (
            <p className="text-gray-500 text-center py-10">
                No paintings available.
            </p>
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 md:gap-y-16">
            {paintings.map((painting) => (
                <PaintingCard key={painting._id} painting={painting} />
            ))}
        </div>
    );
};

export default PaintingList;